import React, { useEffect, useState } from "react";
import "./UpcomingTrips.css";
import { useNavigate } from "react-router-dom";

const API_URL = "https://sheetdb.io/api/v1/bkpus34ip4xtl"; // replace with your real SheetDB API URL

const UpcomingTrips = () => {
  const [trips, setTrips] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API_URL}`)
      .then((res) => res.json())
      .then((data) => setTrips(data))
      .catch((err) => console.error("Fetch error:", err));
  }, []);

  return (
    <section className="upcoming-trips">
      <h2>Our Upcoming Holiday Plans</h2>
      <div className="trip-slider">
        {trips.map((trip, index) => (
          <div className="trip-card" key={index}>
            <img src={trip.imageURL} alt={trip.title} />
            <h3>{trip.title}</h3>
            <h4>{trip.subheading}</h4>
            <p>{trip.description}</p>
            <p className="price">{trip.price}</p>
            <button onClick={() => navigate(`/trip-itinerary/${trip.title}`)}>Know More</button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default UpcomingTrips;
